import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import Complete from './Complete'
import { getFeaturedBreaks } from 'services/break'

/*

*/
const CompleteStep = ({
  step,
  breakId,
  isEmbed,
  isComplete,
  onStepStart,
  onStepComplete,
  brk,
}) => {
  const [featuredBreaks, setFeaturedBreaks] = useState([])

  const retrieveFeaturedBreaks = async () => {
    try {
      const response = await getFeaturedBreaks({ limit: 7 })
      setFeaturedBreaks(response.detail)
    } catch (e) {
      // a 401 can get thrown for guests
      console.log(e)
    }
  }

  useEffect(() => {
    if (isEmbed) {
      setFeaturedBreaks([])
    } else {
      retrieveFeaturedBreaks()
    }
  }, featuredBreaks)

  return (
    <>
      <Complete
        step={step}
        breakId={breakId}
        isComplete={isComplete}
        onStepStart={onStepStart}
        onStepComplete={onStepComplete}
        isStarted={true}
        featuredBreaks={featuredBreaks}
        isEmbed={isEmbed}
        facebookEnabled={brk && brk.showFBComments ? true : false}
      />
    </>
  )
}

export default CompleteStep
